var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
var ValidationMessagesComponent = /** @class */ (function () {
    function ValidationMessagesComponent(elementRef, appLocalizationService) {
        this.elementRef = elementRef;
        this.appLocalizationService = appLocalizationService;
        this.errorDefs = [];
        this._elementRef = elementRef;
        this._appLocalizationService = appLocalizationService;
    }
    ValidationMessagesComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            var targetElements = $(_this._elementRef.nativeElement).parent().find('[name=\'' + _this.formCtrl.name + '\']');
            if (!targetElements || targetElements.length > 1) {
                return;
            }
            var targetElement = $(targetElements[0]);
            if (targetElement.attr('required')) {
                _this.errorDefs.push({ required: _this._appLocalizationService.l('ThisFieldIsRequired') });
            }
            if (targetElement.attr('minlength')) {
                _this.errorDefs.push({ minlength: _this._appLocalizationService.l('PleaseEnterAtLeastNCharacter', targetElement.attr('minlength')) });
            }
            if (targetElement.attr('maxlength')) {
                _this.errorDefs.push({ maxlength: _this._appLocalizationService.l('PleaseEnterNoMoreThanNCharacter', targetElement.attr('maxlength')) });
            }
            if (targetElement.attr('pattern')) {
                var tips = targetElement.attr('data-pattern');
                if (tips) {
                    _this.errorDefs.push({ pattern: tips });
                }
            }
        });
    };
    ValidationMessagesComponent.prototype.getErrorDefinitionIsInValid = function (errorDef) {
        return !!this.formCtrl.errors[Object.keys(errorDef)[0]];
    };
    ValidationMessagesComponent.prototype.getErrorDefinitionMessage = function (errorDef) {
        return errorDef[Object.keys(errorDef)[0]];
    };
    ValidationMessagesComponent.prototype.addValidationDefinitionIfNotExists = function (validationKey, validationMessage) {
        if (this.errorDefs[validationKey]) {
            return;
        }
        this.errorDefs.push({ validationKey: validationMessage });
    };
    __decorate([
        Input()
    ], ValidationMessagesComponent.prototype, "formCtrl", void 0);
    __decorate([
        Input()
    ], ValidationMessagesComponent.prototype, "errorDefs", void 0);
    ValidationMessagesComponent = __decorate([
        Component({
            selector: '<validation-messages>',
            template: "<div class=\"has-danger\" *ngIf=\"formCtrl.invalid && formCtrl.dirty\">\n                    <div *ngFor=\"let errorDef of errorDefs\">\n                        <div *ngIf=\"getErrorDefinitionIsInValid(errorDef)\" class=\"form-control-feedback\">\n                            {{getErrorDefinitionMessage(errorDef)}}\n                        </div>\n                    </div>\n               </div>"
        })
    ], ValidationMessagesComponent);
    return ValidationMessagesComponent;
}());
export { ValidationMessagesComponent };
